module.exports = __webpack_public_path__ + "img/social-media-display-infiniti.37c2a477.png";